import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Styles } from "./components/Styles";
import { Testimonials } from "./components/Testimonials";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Testimonials />
      <Styles />
    </div>
  );
}

export default App;
